<template lang="html">

  <div data="experiencia" class="cv-part">

    <h2 @click="openedit" class="title" :edit="showedit" :empty="!!!info">Experiencia</h2>

    <template v-if="!!info">
      <article class="experiencia-el" v-for="exp in info" v-if="info.length != 0">
        <div class="edit-options" :edit="showedit">
          <button class="editar" @click="setEditar(exp)"">Editar</button>
          <button class=" eliminar" @click="eraseExperiencia(exp.id)">✕</button>
          <p :edit="showedit" class="experiencia">{{$t(`meses[${exp.mesinicio-1}]`)}} {{exp.anioinicio}} -
            {{(exp.mesfin != 'Actualidad') ? $t(`meses[${exp.mesfin-1}]`) : ''}}
            {{exp.aniofin}}. <strong v-html="exp.puesto"></strong>. <span v-html="exp.empresa"></span>, {{exp.ubicacion}}</p>
          <p class="funcion" v-html="exp.funcion"></p>
          <a v-if="!!exp.adjunto" :href="exp.adjunto" target="_blank" class="link">Ver documento adjunto</a>
          <a :title="exp.enlace" v-if="!!exp.enlace" :href="(exp.enlace.includes('http')) ? exp.enlace : 'https://'+exp.enlace" target="_blank" class="link">Ver enlace
            adjunto</a>
        </div>
      </article>
    </template>
    <template v-if="!!!info || info.length == 0">
      <p>Aún no tienes experiencia añadida, pulsa en añadir experiencia para añadirla</p>
    </template>

    <button class="btn skull" @click="setPopup">+ Añadir experiencia</button>

    <div class="cover-popup row-center" v-if="showadd">
      <div class="popup">
        <a class="close" @click="showadd = false">✕</a>
        <h2 class="title-pop">
          {{(!!!newexperiencia.id) ? 'Añadir experiencia laboral' : 'Editar experiencia laboral'}}
        </h2>

        <label for="">Puesto</label>
        <input type="text" name="puesto" v-validate="'required'" v-model="newexperiencia.puesto" placeholder="Puesto"
          :error="errors.has('puesto')">
        <span class="error animated shake" v-if="errors.has('puesto')">{{ errors.first('puesto') }}</span>

        <label for="">Empresa</label>
        <input type="text" name="empresa" v-validate="'required'" v-model="newexperiencia.empresa" placeholder="Empresa"
          :error="errors.has('empresa')">
        <span class="error animated shake" v-if="errors.has('empresa')">{{ errors.first('empresa') }}</span>

        <label for="">Sector</label>
        <select v-model="newexperiencia.sector" v-validate="'required'" name="sector" :error="errors.has('sector')">
          <option value="">Selecciona tu sector</option>
          <option v-for="(sector,key) in dominiosorder.sectores" :value="sector[0]">{{sector[1]}}</option>
        </select>
        <span class="error animated shake" v-if="errors.has('sector')">{{ errors.first('sector') }}</span>

        <label for="">Ubicación</label>
        <input type="text" name="ubicacion" v-validate="'required'" v-model="newexperiencia.ubicacion"
          placeholder="Ubicación" :error="errors.has('ubicacion')">
        <span class="error animated shake" v-if="errors.has('ubicacion')">{{ errors.first('ubicacion') }}</span>

        <div class="contenedor-fechas row-center ais">

          <div class="datepicker-container" :error="errors.has('fechainicio')">
            <label for="">Desde</label>
            <datepicker :placeholder="'Fecha de Inicio'" :language="es" :full-month-name="true" :monday-first="true"
              :format="'MMMM yyyy'" :minimum-view="'month'" v-model="fechainicio" v-validate="'required'"
              :required="true" name="fechainicio"></datepicker>
            <span class="error animated shake" v-if="errors.has('fechainicio')">{{ errors.first('fechainicio') }}</span>
          </div>

          <div class="datepicker-container" :actualidad="newexperiencia.actualidad" :error="errors.has('fechafin')">
            <label for="">Hasta</label>
            <div class="toggle-checkbox" :edit="showadd">
              <input type="checkbox" id="actualidad" v-model="newexperiencia.actualidad" @change="validateDate">
              <label for="actualidad">Actualidad</label>
            </div>
            <datepicker :disabled="!!newexperiencia.actualidad" :placeholder="'Fecha de Fin'" :language="es"
              :full-month-name="true" :monday-first="true" :format="'MMMM yyyy'" :minimum-view="'month'"
              v-model="fechafin" v-validate="(!!!newexperiencia.actualidad) ? 'required' : ''" name="fechafin">
            </datepicker>
            <span class="error animated shake" v-if="errors.has('fechafin')">{{ errors.first('fechafin') }}</span>
          </div>
        </div>


        <label for="">Función</label>
        <div class="textarea">
          <textarea name="funcion" v-validate="'required'" v-model="newexperiencia.funcion"
            placeholder="Descripción del puesto" id="interesesprofesionales"></textarea>
          <span class="error animated shake" v-if="errors.has('funcion')">{{ errors.first('funcion') }}</span>
        </div>

        <label for="">Enlace</label>
        <input type="text" name="enlace" v-validate="'url'" v-model="newexperiencia.enlace" placeholder="Url"
          :error="errors.has('enlace')">
        <span class="error animated shake" v-if="errors.has('enlace')">{{ errors.first('enlace') }}</span>


        <div class="dropzone column-center" :error="errors.has('docfile')"
          :attached="attached && !errors.has('docfile')">
          <input type="file" @change="handleFileUpload($event)" v-validate="`size:1500|mimes:${formatosPermitidos}`"
            name="docfile">
          <template v-if="!attached">
            <img src="@/assets/img/file.svg" alt="Subir archivo">
            <p>Haz click o arrastra el archivo para añadirlo</p>
          </template>
          <template v-if="attached && !errors.has('docfile')">
            <img src="@/assets/img/tick.svg" alt="Subir archivo">
            <p>Archivo adjunto</p>
            <a @click="eraseDoc" class="erase">Eliminar</a>
          </template>
          <template v-if="attached && errors.has('docfile')">
            <img src="@/assets/img/cancel.svg" alt="Subir archivo">
            <span class="error animated shake" v-if="errors.has('docfile')">{{ errors.first('docfile') }}</span>
            <a @click="eraseDoc" class="erase">Eliminar</a>
          </template>
        </div>

        <button class="btn" @click="checkexperiencia" :loading="loading">
          {{(!!!newexperiencia.id) ? 'Añadir experiencia' : 'Editar experiencia'}}
        </button>


      </div>
    </div>

  </div>

</template>

<script lang="js">

  import { mapActions, mapGetters } from 'vuex';

  import { es } from 'vuejs-datepicker/dist/locale';

  import Datepicker from 'vuejs-datepicker';

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  import { Validator } from "vee-validate";

  Vue.use(VeeValidate);


  export default {
    name: 'experiencia',
    props: ['info'],
    data() {
      return {
        showadd: false,
        showedit: false,
        loading: false,
        newexperiencia: {
          sector: '',
          enlace: '',
          funcion: '',
          ubicacion: '',
          empresa: '',
          puesto: '',
          mesinicio: '',
          anioinicio: '',
          mesfin: '',
          aniofin: '',
          adjunto: '',
          extension_adjunto: '',
          actualidad: false
        },
        fechafin: '',
        fechainicio: '',
        es: es,
        attached: false,
        formatosPermitidos: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/msword', 'application/vnd.oasis.opendocument.text', 'application/vnd.ms-powerpoint', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.ms-excel', 'vnd.ms-excel', 'image/*', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'image/jpg', 'image/jpeg', 'image/png'],
        relacionFormato: {
          'vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
          'vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
          'pdf': 'pdf',
          'msword': 'doc',
          'vnd.oasis.opendocument.text': 'odt',
          'vnd.ms-powerpoint': 'ppt',
          'vnd.oasis.opendocument.presentation': 'odp',
          'vnd.ms-excel': 'csv',
          'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
          'msword': 'doc'
        }
      }
    },
    methods: {
      ...mapActions(['eraseExperiencia', 'addExperiencia', 'editExperiencia', 'canEditCv']),
      checkexperiencia() {

        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            this.loading = true;
            this.setFecha();
            if (!!!this.newexperiencia.id) {
              this.addExperiencia(this.newexperiencia).then(r => {
                if (r) {
                  this.loading = false;
                  this.showadd = false;
                }
              });
            } else {
              this.editExperiencia(this.newexperiencia).then(r => {
                if (r) {
                  this.loading = false;
                  this.showadd = false;
                }
              });
            }
          }

        });

      },
      setFecha() {
        if (!!this.newexperiencia.actualidad) {
          this.newexperiencia.mesfin = 'Actualidad';
          this.newexperiencia.aniofin = 'Actualidad';
        } else if (!!this.fechafin) {
          let fechafin = new Date(this.fechafin);
          this.newexperiencia.mesfin = fechafin.getMonth() + 1;
          this.newexperiencia.aniofin = fechafin.getFullYear();
        }

        let fechainicio = new Date(this.fechainicio);
        this.newexperiencia.mesinicio = fechainicio.getMonth() + 1;
        this.newexperiencia.anioinicio = fechainicio.getFullYear();

      },
      handleFileUpload() {

        let file = event.target.files[0];

        let type = file.type.split("/")[1];

        this.newexperiencia.extension_adjunto = (!!this.relacionFormato[type]) ? this.relacionFormato[type] : type;

        this.getBase64(file).then(data => {
          this.newexperiencia.adjunto = data;
          this.attached = true;
        });

      },
      getBase64: function (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },
      reset() {
        for (let i in this.newexperiencia) {
          this.newexperiencia[i] = '';
        }
        this.attached = false;
        this.fechafin = '';
        this.fechainicio = '';
      },
      setPopup() {
        this.canEditCv().then(r => {
          (r) ? this.showadd = true : '';
          this.reset();
        });
      },
      openedit() {
        this.canEditCv().then(r => {
          if(!!!this.info){
            (r) ? this.showadd = !this.showadd : '';
          }else{
            (r) ? this.showedit = !this.showedit : '';
        }
        });
      },
      setEditar(exp) {
        //REPLACE BR
        const regex = /<br\s*[\/]?>/gi;
        exp.funcion = exp.funcion.replace(regex, "\n");

        exp.puesto = exp.puesto.replace("&amp;","&")
        exp.empresa = exp.empresa.replace("&amp;","&")


        this.newexperiencia = JSON.parse(JSON.stringify(exp));
        this.showadd = true;
        this.fechainicio = new Date(this.newexperiencia.anioinicio, this.newexperiencia.mesinicio - 1);
        this.attached = (!!this.newexperiencia.adjunto);
        if (this.newexperiencia.aniofin == 'Actualidad') {
          this.newexperiencia.actualidad = true;
        } else {
          this.fechafin = new Date(this.newexperiencia.aniofin, this.newexperiencia.mesfin - 1);
        }
      },
      eraseDoc() {
        this.newexperiencia.adjunto = '';
        this.newexperiencia.extension_adjunto = '';
        this.attached = false;
        this.$validator.validateAll();
      },
      validateDate(){
				this.$validator.validate('fechafin');
			},	
    },
    computed: {
      ...mapGetters({
        dominios: 'getDominios'
      }),
      dominiosorder() {
        let dominios = new Object();
        if (!!this.dominios) {
          let toorder = ['areafuncional', 'sectores', 'contratos'];
          toorder.forEach(e => {
            let tipos = Object.entries(this.dominios[e]);
            dominios[e] = tipos.sort(function (p1, p2) {
              return (p1[1] < p2[1]) ? -1 : 1;
            })
          });
        }
        return dominios;
      },
    },
    components: {
      Datepicker
    }
  }
</script>

<style scoped lang="scss">
  select,
  textarea {
    margin-bottom: 20px;

    &[aria-invalid=true] {
      margin-bottom: 0;
    }
  }

  input {
    width: 100%;
    margin-bottom: 20px;

    &[aria-invalid=true] {
      margin-bottom: 0;
    }
  }

  .cover-popup .popup {
    max-height: 90vh;
    max-width: 700px;
    overflow: scroll;
  }

  .dropzone {
    height: 130px;
  }

  @media screen and (max-width: 440px){
		input,select,textarea{
			margin-bottom: 10px;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/experiencia.vue